// Typography — Vercel-inspired (DESIGN.md)
export const typography = {
  fontFamily: {
    sans: ['Inter', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica Neue', 'Arial', 'sans-serif'],
    mono: ['JetBrains Mono', 'ui-monospace', 'SFMono-Regular', 'Menlo', 'Monaco', 'Consolas', 'Liberation Mono', 'Courier New', 'monospace'],
  },

  fontSize: {
    xs: ['0.75rem', { lineHeight: '1rem' }],
    sm: ['0.875rem', { lineHeight: '1.25rem' }],
    base: ['1rem', { lineHeight: '1.5rem' }],
    lg: ['1.125rem', { lineHeight: '1.75rem' }],
    xl: ['1.25rem', { lineHeight: '1.75rem' }],
    '2xl': ['1.5rem', { lineHeight: '2rem' }],
    '3xl': ['1.875rem', { lineHeight: '2.25rem' }],
    '4xl': ['2.25rem', { lineHeight: '2.5rem' }],
    '5xl': ['3rem', { lineHeight: '1' }],
    '6xl': ['3.75rem', { lineHeight: '1' }],
  },

  fontWeight: {
    normal: '400',
    medium: '500',
    semibold: '600',
  },

  lineHeight: {
    none: '1',
    tight: '1.25',
    snug: '1.375',
    normal: '1.5',
    relaxed: '1.625',
    loose: '2',
  },

  letterSpacing: {
    displayXl: '-0.05em',
    displayLg: '-0.04em',
    displayMd: '-0.04em',
    displaySm: '-0.03em',
    bodySm: '-0.02em',
    normal: '0em',
  },

  tokens: {
    displayXl: { fontSize: '3rem', lineHeight: '3rem', fontWeight: '600', letterSpacing: '-0.05em' },
    displayLg: { fontSize: '2rem', lineHeight: '2.5rem', fontWeight: '600', letterSpacing: '-0.04em' },
    displayMd: { fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600', letterSpacing: '-0.04em' },
    displaySm: { fontSize: '1.25rem', lineHeight: '1.75rem', fontWeight: '600', letterSpacing: '-0.03em' },
    bodyLg: { fontSize: '1.125rem', lineHeight: '1.75rem', fontWeight: '400', letterSpacing: '0' },
    bodyMd: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: '400', letterSpacing: '0' },
    bodyMdStrong: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: '500', letterSpacing: '0' },
    bodySm: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '400', letterSpacing: '-0.02em' },
    bodySmStrong: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '500', letterSpacing: '-0.02em' },
    caption: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '400', letterSpacing: '0' },
    captionMono: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '400', letterSpacing: '0', fontFamily: 'mono' },
    code: { fontSize: '0.8125rem', lineHeight: '1.25rem', fontWeight: '400', letterSpacing: '0', fontFamily: 'mono' },
    buttonMd: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '500', letterSpacing: '0' },
    buttonLg: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: '500', letterSpacing: '0' },
  },

  textStyles: {
    h1: { fontSize: '2rem', lineHeight: '2.5rem', fontWeight: '600', letterSpacing: '-0.04em' },
    h2: { fontSize: '1.5rem', lineHeight: '2rem', fontWeight: '600', letterSpacing: '-0.04em' },
    h3: { fontSize: '1.25rem', lineHeight: '1.75rem', fontWeight: '600', letterSpacing: '-0.03em' },
    h4: { fontSize: '1.125rem', lineHeight: '1.75rem', fontWeight: '600', letterSpacing: '-0.02em' },
    h5: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: '600', letterSpacing: '0' },
    h6: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '600', letterSpacing: '0' },
    body: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '400', letterSpacing: '-0.02em' },
    bodyLarge: { fontSize: '1.125rem', lineHeight: '1.75rem', fontWeight: '400', letterSpacing: '0' },
    bodySmall: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '400', letterSpacing: '0' },
    label: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '500', letterSpacing: '0' },
    caption: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '400', letterSpacing: '0' },
    captionMono: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      fontWeight: '400',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
    },
    tableHeader: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      fontWeight: '400',
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
    },
    button: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '500', letterSpacing: '0' },
    buttonLarge: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: '500', letterSpacing: '0' },
    buttonSmall: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '500', letterSpacing: '0' },
    sidebarLogo: { fontSize: '1.125rem', lineHeight: '1.5rem', fontWeight: '600', letterSpacing: '-0.02em' },
    sidebarNav: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '400', letterSpacing: '-0.02em' },
    sidebarSectionHeader: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '400', letterSpacing: '0.05em', textTransform: 'uppercase' },
    sidebarUserRole: { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: '400', letterSpacing: '0' },
    headerTitle: { fontSize: '1.25rem', lineHeight: '1.75rem', fontWeight: '600', letterSpacing: '-0.03em' },
    cardTitle: { fontSize: '1.125rem', lineHeight: '1.5rem', fontWeight: '600', letterSpacing: '-0.02em' },
    cardSubtitle: { fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: '400', letterSpacing: '-0.02em' },
  },
};

export const getFontSize = (size) => typography.fontSize[size] || typography.fontSize.base;
export const getFontWeight = (weight) => typography.fontWeight[weight] || typography.fontWeight.normal;
export const getTextStyle = (style) => typography.textStyles[style] || typography.textStyles.body;
